import {UsaStates} from 'usa-states';
import canada from 'canada';
import {CountryCodes} from './Countries';

let UsStates = {};

new UsaStates().states.forEach((usState) => {
  UsStates[usState.abbreviation] = usState.name;
});

const caProvinces = canada.provinces;

let CanadianProvinces = {};

Object.keys(caProvinces).forEach((provinceCode) => {
  CanadianProvinces[provinceCode] = caProvinces[provinceCode];
});

const resolveRegionCodeFromName = (regionName, countryCode) => {
  if (!regionName || !countryCode) {
    return regionName;
  }
  // Check if matches region code
  if (countryCode === CountryCodes.US) {
    const usStateCodes =  Object.keys(UsStates);
    for (let i = 0; i < usStateCodes.length; i++) {
      const usStateCode = usStateCodes[i];
      if(regionName.toUpperCase() === usStateCode.toUpperCase()) {
        return usStateCode;
      }
      if(regionName.toUpperCase() == UsStates[usStateCode].toUpperCase()) {
        return usStateCode;
      }
    }
  }
  if (countryCode === CountryCodes.CA) {
    const caProvinceCodes =  Object.keys(CanadianProvinces);
    for (let i = 0; i < caProvinceCodes.length; i++) {
      const caProvinceCode = caProvinceCodes[i];
      if(regionName.toUpperCase() === caProvinceCode.toUpperCase()) {
        return caProvinceCode;
      }
      if(regionName.toUpperCase() == CanadianProvinces[caProvinceCode].toUpperCase()) {
        return caProvinceCode;
      }
    }
  }
  return regionName;
};

const getRegionsByCountryCode = (countryCode) => {
  if(countryCode === 'US') {
    return UsStates;
  }
  if(countryCode === 'CA') {
    return CanadianProvinces;
  }
  return {};
};

export {
  UsStates,
  CanadianProvinces,
  getRegionsByCountryCode,
  resolveRegionCodeFromName
};
